export default __webpack_public_path__ + "static/media/ic_jersey.1595a19d.svg";